import { KeywordTier } from '@rsos/reduxDataStore';
import styled from '@rsos/theme/styled';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Message = styled.div`
  display: flex;
  align-items: center;
`;

export const KeywordChip = styled.div<{ tierId: KeywordTier['id'] }>`
  background-color: ${props => {
    if (props.tierId === 'tier-1') {
      return props.theme.colors.lightDanger;
    }
    if (props.tierId === 'tier-2') {
      return props.theme.colors.lightWarning;
    }
    return props.theme.colors.success;
  }};
  color: ${props => {
    if (props.tierId === 'tier-2') {
      return props.theme.colors.lightWarningText;
    }
    return props.theme.colors.background;
  }};
  border-radius: 5px;
  padding: 4px;
  margin-right: 8px;
  font-weight: 500;
  height: 24px;
  max-width: 140px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const CallerId = styled.div`
  font-weight: bold;
  margin-left: 4px;
  margin-right: 4px;
  height: 16px;
  max-width: 130px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
